import { Dayjs } from 'dayjs';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../dto/data-model.js';
import { BusinessModuleRef } from './business-module-ref.js';
import { MapUtils } from '../../utility/map-utils.js';
import { TimeZone } from '../../time/timezone.js';
import { isSameData } from '../dto/data-model-utils.js';

export class OpenAccessPassForSale extends DataModel {
  static readonly TYPE_ID: string = 'df151ea0e11b43b2b4dea6e0707dc317';

  private constructor(
    public readonly businessRef: BusinessModuleRef,
    public readonly uniqueId: string,
    public readonly creationDate: Dayjs,
  ) {
    super();
  }

  get $typeId(): string {
    return OpenAccessPassForSale.TYPE_ID;
  }

  get code(): string {
    return this.uniqueId;
  }

  get scanCode(): string {
    return this.code;
  }

  static create(args: {
    businessRef: BusinessModuleRef,
    uniqueId: string,
    creationDate: Dayjs,
  }): OpenAccessPassForSale {
    return new OpenAccessPassForSale(
        args.businessRef,
        args.uniqueId,
        args.creationDate,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): OpenAccessPassForSale {
    return OpenAccessPassForSale.create({
      businessRef: BusinessModuleRef.mustDecode(MapUtils.getString(map, 'businessRef')),
      uniqueId: MapUtils.getString(map, 'uniqueId'),
      creationDate: context.decodeDate(MapUtils.getNumber(map, 'creationDate')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'businessRef': this.businessRef.encode(),
      'uniqueId': this.uniqueId,
      'creationDate': context.encodeDate(this.creationDate),
    };
  }

  clone(): this {
    return OpenAccessPassForSale.create({
      businessRef: this.businessRef.clone(),
      uniqueId: this.uniqueId,
      creationDate: TimeZone.cloneDate(this.creationDate),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.businessRef, this.businessRef) &&
        other.uniqueId === this.uniqueId &&
        other.creationDate === this.creationDate;
  }
}

export class OpenAccessPassForSaleBuilder extends DataModelBuilder<OpenAccessPassForSale> {
  build(context: SerializationContext, map: SerializedData): OpenAccessPassForSale {
    return OpenAccessPassForSale.fromMap(context, map);
  }
}
